import script from "./OnboardingAiStepActions.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiStepActions.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiStepActions.vue?vue&type=style&index=0&id=0fccc27d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fccc27d"]])

export default __exports__